export enum GenerateSmsOperationType {
	REGISTRATION_FROM_CRM = 'REGISTRATION_FROM_CRM',
	DELETING_CERTIFICATE = 'DELETING_CERTIFICATE',
	OFF_OTP_FOR_LOGIN = 'OFF_OTP_FOR_LOGIN',
	ON_OTP_FOR_LOGIN = 'ON_OTP_FOR_LOGIN',
}

export enum GenerateSmsInitiator {
	DBOUL = 'DBOUL',
	CRM = 'CRM',
}

export interface GenerateSmsData {
	phone?: string
	flCrmId: number
	systemInitiator: string
	operationType: GenerateSmsOperationType
}

export interface VerifySmsData extends GenerateSmsData {
	smsCode: string
	verifyId: number
}

export interface GenerateSmsResultData {
	id: number
}